module.exports = __webpack_public_path__ + "img/logo_zdp.0e05c43e.jpg";